import "./style.less";

/**
 * THIS IS MEANT AS AN OVERVIEW OF ALL POSSIBLE NOTIFICATIONS (DISABLED IN PROD)
 */
export default function UiNotificationsOnPage() {
    return {
        restrict: "E",
        scope: {
            notifications: "<",
        },
        template: require("./template.html"),

        controller: function ($scope, ENV) {
            $scope.envType = ENV.type;
        },
    };
}
